import { PureComponent, type ReactNode } from "react";
import { CircleQuestionIcon } from "@App/Components/common/Icons";

export class Footer extends PureComponent {
  render(): ReactNode {
    return (
      <div className="md:h-16 bg-gray-100 text-neutral-500 text-sm p-4">
        <div className="container h-full md:flex items-center justify-end">
          <div className="flex gap-5 items-center">
            <div className="flex gap-2">
              <CircleQuestionIcon className="w-4 h-w" />
              <a href="#" className="text-neutral-500 no-underline font-semibold hover:underline">
                FAQs
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
